var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManageAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.6 11.536c1.768 0 3.2-1.422 3.2-3.178 0-1.757-1.432-3.18-3.2-3.18-1.768 0-3.2 1.423-3.2 3.18 0 1.756 1.432 3.178 3.2 3.178zm0 1.59c-2.136 0-6.4 1.065-6.4 3.178v1.59H18v-1.59c0-2.113-4.264-3.178-6.4-3.178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h19.2v19.073H2z"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/manage-account.svg";
export { SvgManageAccount as ReactComponent };